<template>
<div>
  <div>
    <el-date-picker v-fixZoom
      size="small"
      v-model="sendDate"
      type="daterange"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptions"
      value-format="yyyy-MM-dd"
      style="width: 400px;margin-left: 20px"
      :clearable="false">
    </el-date-picker>
    <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
  </div>
  <div style="height: 10px"></div>
  <div style="height: 400px">
<!--    <div class="map_container" style="height: 100%" ref="map_container"></div>-->
    <iframe id="mainIframe"
            ref="mainIframe"
            name="mainIframe"
            :style="{width: '100%', height: '100%', margin: 'auto', zoom: 1 / this.golobleObject.zoom}"
            src="../../../../static/trackMap.html"
            frameborder="0"
            scrolling="no">
    </iframe>
  </div>
  <div style="height: 20px"></div>
</div>
</template>

<script>
import {querydevicehistoryposition} from '../../../api/device'

export default {
  name: 'historyTrack',
  model: {
    prop: 'trackShow',
    event: 'change'
  },
  props: {
    trackObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      map: null,
      sendDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      isStart: false,
      positionArr: []
    }
  },
  created () {
    this.golobleObject.sendIsStart = this.sendIsStart
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyy-MM-dd')
    // const start = new Date()
    // start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    // this.time(start)
    this.sendDate = [date, date]
    this.onSubmit()
  },
  mounted () {
    // this.init()
  },
  methods: {
    time (date) {
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let minute = date.getMinutes()
      minute = minute < 10 ? '0' + minute : minute
      let second = date.getSeconds()
      second = second < 10 ? '0' + second : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    },
    init () {
      /* eslint-disable */
      this.map = new AMap.map(this.$refs.map_container, {
        zoom: 16
      })
    },
    sendIsStart () {
      this.isStart = true
      if (this.positionArr.length !== 0) {
        this.sendMapShow()
      }
    },
    sendMapShow () {
      window.frames['mainIframe'].window.getParentTrack(this.positionArr)
    },
    onSubmit () {
      let imei = ''
      if (this.trackObj.type === 'device') { // 设备管理
        imei = this.trackObj.deviceRow.deviceid
      } else { // 事件处理 弹窗
        imei = this.trackObj.alarmRow.device.deviceid
      }
      let data = {
        imei: imei,
        from: this.sendDate[0] + ' 00:00:00',
        to: this.sendDate[1] + ' 23:59:59'
      }
      querydevicehistoryposition(data).then(res => {
        this.positionArr = res.data.devicepositions
        if (this.isStart) {
          if (this.positionArr.length !== 0) {
            this.sendMapShow()
          }
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/historyTrack.vue